export default "__VITE_ASSET__CR8f3Iaf__"